import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const AdminProtectedRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (!user || !user.isAdmin) {
        // Redirect to home or login page if not an admin
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AdminProtectedRoute;